import React from 'react'
import PermissionErrorPage from '../../../pages/PermissionError'

const NoPermissionContainer = ({ error, skipAgentPage, children }) => {
  if (error) {
    let { err, axiosError, response } = error

    if (!axiosError) {
      axiosError = err?.axiosError
    }
    // Account for response not being directly in the error object
    if (!response) {
      response = axiosError?.response
    }

    if (response?.status === 403) {
      return <PermissionErrorPage skipAgentPage={skipAgentPage} />
    }
  }

  return children
}

export default NoPermissionContainer
